/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the PushConfigResponse interface.
 */
export function instanceOfPushConfigResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function PushConfigResponseFromJSON(json) {
    return PushConfigResponseFromJSONTyped(json, false);
}
export function PushConfigResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'publicKey': !exists(json, 'publicKey') ? undefined : json['publicKey'],
    };
}
export function PushConfigResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enabled': value.enabled,
        'publicKey': value.publicKey,
    };
}
